import { get } from "services/BaseClient/Client";
import endpoints from "./EndPoints"
import headers from "services/BaseClient/Headers.json";




export const getCompanyList = async () => {
    
    const url = `${endpoints.getCompanies}`;
    const config = headers.content_type.application_json;
    return get(url, config);
};


